import { EmptyState } from '@/components/EmptyState/EmptyState';
import { useAmelioTranslations } from '@/hooks';

interface CompensationEmptyStateProps {
    /** Every reader of the report may create an envelope of their own. */
    onCreate: () => void;
}

/** What the cycle shows before it holds a single envelope: the sentence that says so, and the one
 * action that changes it. */
export const CompensationEmptyState = ({ onCreate }: CompensationEmptyStateProps) => {
    const { t } = useAmelioTranslations();

    return (
        <EmptyState
            title={t('compensation.empty.noEnvelope.title')}
            message={t('compensation.empty.noEnvelope.message')}
            action={{
                label: t('compensation.tabs.newEnvelope'),
                onClick: onCreate,
                iconName: 'essential-add',
            }}
        />
    );
};
